export const mapToSummaryObj = (inputForm) => {
    return {
        apnName: inputForm.apnName,
        showVrf: inputForm.vrfName !== "",
        vrfName: inputForm.vrfName
    }
}
